<template>
  <div class="page-frame" v-if="pageData" role="main">
    <div
      v-if="pageData.acf && pageData.acf['header_image'] && isHomePage"
      class="header-image"
      role="banner"
    >
      <v-img
        v-bind:src="pageData.acf['header_image'].url"
        v-bind:alt="pageData.acf['header_image'].alt"
      ></v-img>
    </div>
    <div class="container">
      <div
        v-if="pageData.acf && pageData.acf['header_image'] && !isHomePage"
        class="header-image"
        role="banner"
      >
        <v-img
          v-bind:src="pageData.acf['header_image'].url"
          v-bind:alt="pageData.acf['header_image'].alt"
          aspect-ratio="3"
        ></v-img>
      </div>
      <h1
        class="page-title"
        v-if="pageData.acf && pageData.acf['display_page_title']"
        role="banner"
      >{{pageData.title.rendered}}</h1>
      <div v-html="pageData.content.rendered"></div>

      <div v-if="isHomePage" class="funded-container">
        <div class="divider" v-bind:class="{contrastMode}" />
        <p class="text">{{ $t("WARSAW_FUNDING.TEXT") }}</p>
        <img
          src="../assets/warsaw_funded.png"
          class="image"
          aria-label="$('WARSAW_FUNDING.IMAGE_ALT')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page",
  props: {
    pageData: Object,
    homePageId: Number,
    contrastMode: Boolean
  },
  data: () => {
    return {
      isHomePage: false
    };
  },
  created() {
    this.isHomePage = this.pageData && this.pageData.id === this.homePageId;
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_global";
.funded-container {
  width: 100%;
  text-align: center;
  margin-bottom: 60px;

  .text {
    margin-bottom: 30px;
  }

  .divider {
    height: 1px;
    background-color: $accentColor;
    margin: 80px 20px;
  }

  .divider.contrastMode {
    background-color: $darkTextColor;
  }

  .image {
    max-width: 260px;
  }
}
</style>
